import React from "react";
import PublicLayout from "../Layouts/Public";
import TitleAndInfo from "../TitleAndInfo";
import languages from "../../language/languages";
import { MailOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button } from "antd";
import {Field, reduxForm} from "redux-form";
import {CreateTextField} from "../../helpers/InputCreator";
import {email, emailen, required, requireden} from "../../helpers/validations";
import {userNormalizer} from "../../helpers/normalizers";
import {connect} from "react-redux";
import login from "../../actions/login";
import {push} from "connected-react-router";
import forgotPassword from "../../actions/forgotPassword";

class ForgotPassword extends React.Component
{
    render() {
        return (
            <PublicLayout isRA={this.props.isRA} title={'logo'}>
                <TitleAndInfo info={languages[this.props.language].forgotPasswordmsg}/>
                <Form onSubmit={this.props.handleSubmit(this.props.forgotPassword)}>
                    <Field name="mail"
                           prefix={<MailOutlined className={'icon-font'} />}
                           component={CreateTextField}
                           size={'large'}
                           style={{marginBottom: '5px'}}
                           placeholder={languages[this.props.language].mail}
                           validate={this.props.language==='es'?[required,email]:[requireden,emailen]}
                           normalize={userNormalizer}
                           hasFeedback/>
                    <Form.Item className={'text-center mb-10'}>
                        <Button type="primary" htmlType="submit" className={'light-blue rounded'}>
                            {languages[this.props.language].forgotBtn}
                        </Button>
                    </Form.Item>
                    <Form.Item className={'text-center'}>
                        <Button onClick={()=>this.props.push('/')} type="primary" className={'light-blue rounded'}>
                            {languages[this.props.language].goBack}
                        </Button>
                    </Form.Item>
                </Form>
            </PublicLayout>
        );
    }
}

const mapStateToProps = state => {
    return {
        language: state.auth.language,
        isRA: state.auth.isRA
    };
};

export default connect(mapStateToProps, {login, push,forgotPassword})((reduxForm({form: 'forgot_form'})(ForgotPassword)));
